// src/components/PopupManager/PopupManager.component.jsx
import React, { useEffect } from 'react';
import { useNavBar } from '../../../Contexts/navbar.items.context.jsx';
import { useBoxContext } from '../../../Contexts/boxData.context.jsx';

import PurpleManBox from '../../Boxes/PurpleMan/purpleMan.component.jsx';
import S1Search from '../../Boxes/S1Search/S1Search.component.jsx';
import S2Box from '../../Boxes/S2Box/S2Box.component.jsx';
import LittleBox from '../../Boxes/LittleBox/littleBox.component.jsx';
import AlertBox from '../../Boxes/AlertBox/alertBox.component.jsx';
import { SearchTwoLayerProvider } from '../../../Contexts/S2Data.context.jsx';
import BugReport from '../../Boxes/BugReport/BugReport.component.jsx';
import LegendBox from '../../Boxes/Legend/Legend.component.jsx';
import PlayerCard from '../../Boxes/TopBarButtons/HDBox/HDBox.component.jsx';
import Transactions from '../../Boxes/TopBarButtons/Trnsactions/transactions.component.jsx';
import BlueTransactions from '../../Boxes/TopBarButtons/BlueTransactions/BlueTransactions.component.jsx';
import DanBox from '../../Boxes/TopBarButtons/TomBox/tomBox.component.jsx';
import L2ListBox from '../../Boxes/SharedList/sharedList.component.jsx';
import NoteEditorPage from '../../Boxes/TopBarButtons/NoteButton/notePopup.component.jsx';
import SharedNotes from '../../Boxes/sharedNote/sharedNote.component.jsx';
import ReportsBox from '../../Boxes/TopBarButtons/ScoutReports/scoutReportListBox.component.jsx';
import ScoutReportBase from '../../Boxes/TopBarButtons/ScoutReports/scoutReportBase.component.jsx';
import NoteBase from '../../Boxes/TopBarButtons/NoteButton/noteBase.component.jsx';
import GoogleCalendar from '../../Boxes/googleCalendar/googleCalendar.component.jsx';
import SavedQueryBox from '../../Boxes/savedQuery/savedQuery.component.jsx';
import Overview from '../../Boxes/TopBarButtons/OverView/overview.component.jsx';
import ExportDropdown from "../../Boxes/TopBarButtons/Export/exportButton.component.jsx";
import Files from '../../Boxes/TopBarButtons/Files/files.component.jsx'
import DraftBoard from '../../Boxes/TopBarButtons/DraftBoard/draftboard.component.jsx';

const InnerPopupManager = () => {
  const { activeSideButton, updateActiveSideButton } = useNavBar();
  const { NoteBoxOpen, NoteBoxID } = useBoxContext();

  const handleCloseButton = (buttonID) => {
    // Close the popup by clearing the active button.
    updateActiveSideButton(buttonID); // '' closes
  };

  useEffect(() => {
    console.log(`PopupManager: Active Side Button changed to '${activeSideButton}'`);
  }, [activeSideButton]);

  return (
    <>
      <SearchTwoLayerProvider>
        {activeSideButton === "CAL" && (
          <GoogleCalendar
            calendarSrc="https://calendar.google.com/calendar/embed?src=n50ej5b903o3p2h3nenbnm8gak%40group.calendar.google.com&ctz=America/Toronto"
            onClose={() => updateActiveSideButton("")}
            width={1200}
            height={800}
          />
        )}
        {activeSideButton === 'user' && (
          <PurpleManBox onClose={() => handleCloseButton('')} buttonID="user" />
        )}
        {activeSideButton === 'S1' && (
          <S1Search onClose={() => handleCloseButton('')} buttonID="S1" />
        )}
        {activeSideButton === 'S2' && (
          <S2Box onClose={() => handleCloseButton('')} buttonID="S2" />
        )}
        {activeSideButton === 'L1' && <LittleBox />}
        {activeSideButton === 'A' && <AlertBox />}
        {activeSideButton === 'Bug' && <BugReport />}
        {activeSideButton === 'legend' && <LegendBox />}
        {activeSideButton === 'hdbox' && <PlayerCard />}
        {activeSideButton === 'transactions' && <Transactions />}
        {activeSideButton === 'Blue' && <BlueTransactions onClose={() => handleCloseButton('')} />}
        {activeSideButton === 'L2' && <L2ListBox />}
        {activeSideButton === 'notes' && <NoteBase />}
        {activeSideButton === 'SN' && <SharedNotes />}
        {activeSideButton === 'reports' && <ReportsBox />}
        {activeSideButton === 'reports1' && <ScoutReportBase />}
        {activeSideButton === 'SQ' && <SavedQueryBox />}
        {activeSideButton === 'Overview' && <Overview/>}
        {activeSideButton === 'Export' && <ExportDropdown onClose={() => handleCloseButton('')} />}
        {activeSideButton === 'DraftBoard' && <DraftBoard />}

        {/* DanBox no longer receives onGlobalLockChange.
            If DanBox needs masking, import useMask() directly inside DanBox. */}
        {activeSideButton === 'TomBox' && <DanBox />}
        {activeSideButton === 'Files' && <Files />}
        {NoteBoxOpen && NoteBoxID != null && <NoteEditorPage />}
      </SearchTwoLayerProvider>
    </>
  );
};

const PopupManager = () => {
  return <InnerPopupManager />;
};

export default PopupManager;
